import { localize } from "utils/localizer";

const i18n = {
    accept: {
        en: (price: string) => `Accept ${price ? ` (${price})` : ""}`,
        de: (price: string) => `Annehmen ${price ? ` (${price})` : ""}`,
    },
    anErrorOccurred: {
        en: "An error occurred",
        de: "Ein Fehler ist aufgetreten",
    },
    answerInvitationSuccess: {
        en: (accept: boolean) => `Invitation successfully ${accept ? "accepted" : "declined"}`,
        de: (accept: boolean) => `Einladung erfolgreich ${accept ? "angenommen" : "abgelehnt"}`,
    },
    at: {
        en: "at",
        de: "um",
    },
    andMore: {
        en: (num: number) => `and ${num} more`,
        de: (num: number) => `und ${num} weitere`,
    },
    bookingTypes: {
        en: {
            blocking: "Blocking",
            meetup: "Meetup",
            standard: "Booking",
            training: "Event",
        },
        de: {
            blocking: "Sperrung",
            meetup: "Treffen",
            standard: "Buchung",
            training: "Event",
        },
    },
    checkIn: {
        en: "Check-in",
        de: "Einchecken",
    },
    checkInSuccess: {
        en: "Successfully checked in",
        de: "Erfolgreich eingecheckt",
    },
    decline: {
        en: "Decline",
        de: "Ablehnen",
    },
    delete: {
        en: "Delete",
        de: "Löschen",
    },
    deletedSuccessfully: {
        en: "Deleted successfully",
        de: "Erfolgreich gelöscht",
    },
    insufficientPermissions: {
        en: "Insufficient permissions",
        de: "Keine Berechtigung",
    },
    newStory: {
        en: "New Story",
        de: "Neue Story",
    },
    today: {
        en: "Today",
        de: "Heute",
    },
    yesterday: {
        en: "Yesterday",
        de: "Gestern",
    },
    description: {
        en: "Description",
        de: "Beschreibung",
    },
    moreInformation: {
        en: "More Information",
        de: "Mehr Informationen",
    },
};

export default localize(i18n);
